module.exports = __webpack_public_path__ + "static/img/1.3173bad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/zh/1.png
// module id = pQ4N
// module chunks = 0